import React from "react";
import { StepViewComponent } from "../../model/steps/steps-model";
import { VerticalListStepView } from "./vertical-list-step-view";

export const DefaultStepView: StepViewComponent = props => (
  <VerticalListStepView {...props} radioMode={false} />
);
